<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <!-- <Header></Header> -->
    <every-con></every-con>
  </div>
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
// 引入主导航栏区域
import Header from "../../../components/space/Header";
// 引入中间搜索区域
import EveryCon from "../../../components/space/apply";
export default {
  data() {
    return {};
  },
  components: {
    top,
    navMenu,
    Header,
    EveryCon,
  },
};
</script>

<style lang="less" scoped>
</style>
